import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export function advisoryboardArticleSlider() {
  const sliderEl = document.querySelector("#advisoryboard_article_slider");
  if (!sliderEl) return;

  const currentEl = sliderEl.querySelector('.swiper-counter .current');
  const totalEl = sliderEl.querySelector('.swiper-counter .total');

  const zeropad2 = (n) => ('00' + n).slice(-2);

  const total = sliderEl.querySelector(".advisoryboard_article_list").childElementCount;
  totalEl.textContent = zeropad2(total);

  const swiper = new Swiper('#advisoryboard_article_slider', {
    loop: false,
    slidesPerView: 1,
    speed: 400,
    autoplay: {
      delay: 7800,
      disableOnInteraction: false,
    },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.advisoryboard_article-next',
      prevEl: '.advisoryboard_article-prev',
    },
    keyboard: {
      enabled: true,
    },
    a11y: {
      containerMessage: '関連記事の紹介。全部で',
      prevSlideMessage: '前の記事へ',
      nextSlideMessage: '次の記事へ',
      slideLabelMessage: '{{index}}本目の記事を表示',
      paginationBulletMessage: '{{index}}本目の記事を表示',
    },
    on: {
      init: function () {
        let currentNum = zeropad2(this.realIndex + 1);
        currentEl.textContent = currentNum;
      },
      slideChange: function () {
        let currentNum = zeropad2(this.realIndex + 1);
        currentEl.textContent = currentNum;
      },
    },
  });
}
